import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

/**
 * Shipping & returns reassurance. Static, gallery-voice copy — kills the
 * "what if it doesn't work in my space?" hesitation at the point of decision.
 * Copy lives in en.json (ListingPage.shippingReturns*) for easy editing.
 */
const SectionShippingReturns = () => {
  return (
    <section className={css.sectionShipping}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.shippingReturnsTitle" />
      </Heading>
      <p className={css.shippingText}>
        <FormattedMessage id="ListingPage.shippingReturnsBody" />
      </p>
    </section>
  );
};

export default SectionShippingReturns;
